export function getOrCreateGuestUserId() {
  const KEY = "chatbot_guest_user_id";

  let guestId = localStorage.getItem(KEY);

  if (!guestId) {
    // crypto.randomUUID() is supported in modern browsers
    guestId = `guest_${crypto.randomUUID()}`;
    localStorage.setItem(KEY, guestId);
  }

  return guestId;
}
